import React from 'react';
import PropTypes from 'prop-types';
const Indentation = ({
  level
}) => {
  const indents = [];
  for (let i = 0; i < level - 1; i += 1) {
    indents.push(/*#__PURE__*/React.createElement("span", {
      className: "indent",
      key: `indent-${i}`
    }));
  }
  return /*#__PURE__*/React.createElement("span", null, indents);
};
Indentation.propTypes = {
  level: PropTypes.number.isRequired
};
export default Indentation;